/* eslint-disable react/display-name */
import React, { lazy, memo } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
const WheelSorterLogsPage = lazy(() => import("./pages/wheel-sorter-logs"));
const PlcMasterPage = lazy(() => import("./pages/wheel-device/PlcMasterPage"));
const PlcSlavePage = lazy(() => import("./pages/wheel-device/PlcSlavePage"));
const WcsManagePage = lazy(() => import("./pages/wheel-device/WcsManagePage"));
const WheelTrackingPage = lazy(() => import("./pages/wheel-tracking"));
const WheelConfigPage = lazy(() => import("./pages/wheel-config"));
const WheelScannerPage = lazy(() =>
  import("./pages/wheel-device/WheelScannerPage")
);
const WheelCabinetPage = lazy(() =>
  import("./pages/wheel-device/WheelCabinetPage")
);
const WheelControllerPage = lazy(() =>
  import("./pages/wheel-device/WheelControllerPage")
);
const WheelConveyorPage = lazy(() =>
  import("./pages/wheel-device/WheelConveyorPage")
);
const WheelServoPage = lazy(() =>
  import("./pages/wheel-device/WheelServoPage")
);
const WheelChutePage = lazy(() =>
  import("./pages/wheel-device/WheelChutePage")
);
const WheelSpacingPage = lazy(() =>
  import("./pages/wheel-device/WheelSpacingPage")
);
const WheelEspPage = lazy(() => import("./pages/wheel-device/WheelEspPage"));
const WheelDevicePage = lazy(() =>
  import("./pages/wheel-device/WheelDevicePage")
);
const WheelSorterDashboardPage = lazy(() => import("./pages/wheel-dashboard"));
const WheelFullChutePage = lazy(() =>
  import("./pages/wheel-device/WheelFullChutePage")
);
const WheelCaptureErrorPage = lazy(() => import("./pages/wheel-capture-error"));

const WheelSorterRoutes = [
  { path: "wheel-log", element: <WheelSorterLogsPage /> },
  { path: "wheel-tracking", element: <WheelTrackingPage /> },
  { path: "plc-master", element: <PlcMasterPage /> },
  { path: "plc-slave", element: <PlcSlavePage /> },
  { path: "wcs-manage", element: <WcsManagePage /> },
  { path: "wheel-scanner", element: <WheelScannerPage /> },
  { path: "wheel-config", element: <WheelConfigPage /> },
  { path: "wheel-controller", element: <WheelControllerPage /> },
  { path: "wheel-cabinet", element: <WheelCabinetPage /> },
  { path: "wheel-conveyor", element: <WheelConveyorPage /> },
  { path: "wheel-servo", element: <WheelServoPage /> },
  { path: "wheel-chute", element: <WheelChutePage /> },
  { path: "wheel-spacing", element: <WheelSpacingPage /> },
  { path: "wheel-esp", element: <WheelEspPage /> },
  { path: "devices", element: <WheelDevicePage /> },
  { path: "dashboard", element: <WheelSorterDashboardPage /> },
  { path: "capture-full-chute", element: <WheelFullChutePage /> },
  { path: "capture-wheel-error", element: <WheelCaptureErrorPage /> },
];


export default WheelSorterRoutes;
